import React from "react";
import { permissionButton } from "../../util/Util";
import { useSelector } from "react-redux";

export default function PrimaryButton(props) {
  const { permission } = useSelector((state) => state.auth);
console.log("props", 
props?.actions ? permissionButton(permission, props?.actions, props?.menu, props?.parent)=== true
? ""
: "hidden" : "");
  return (
    <button
      className={
        `min-w-[154px] h-[44px] gap-[4px] px-[16px] ${
            props?.actions!==undefined ? permissionButton(permission, props?.actions, props?.menu, props?.parent)=== true
            ? ""
            : "hidden" : ""
        } ${
          props.disabled
            ? "bg-[#D7D7D7] text-[#ACACAC] cursor-not-allowed"
            : "bg-[#CF0000] text-white-100"
        }  text-xl flex items-center justify-evenly rounded-md ` + props.styles
      }
      onClick={props.action}
      disabled={props.disabled}
    >
      {props.prefixIcon !== undefined ? props.prefixIcon : null}
      {props.text}
      {props.suffixIcon !== undefined ? props.suffixIcon : null}
    </button>
  );
}
